import {RsnButton} from '@raison/ui-kit';
import React from 'react';
import {env} from '~/environment';
import {appLocalStorage} from '~/shared/persistence';
import {isAndroid, isIOS} from '~/shared/utils/mobileDeviceDetect';
import {BiometryHead} from './BiometryHead/BiometryHead';

export function BiometryBrowserScreen() {
    const activateLater = () => {
        appLocalStorage.biometryStatus.set('Later');

        setTimeout(() => window.restartAppAt('/'), 500);
    };

    const getApp = () => {
        //TODO: make one source of truth for app links
        //now duplicates ShellVersionFallback
        //probably need to store it in ENV
        if (isIOS()) {
            open('https://apps.apple.com/app/1444995068');
        } else if (isAndroid()) {
            open('https://play.google.com/store/apps/details?id=ai.raison.app');
        } else {
            open(new URL('/getapp', env.WEB_URL).toString());
        }
    };

    return (
        <div className={'flex flex-1 flex-col'}>
            <BiometryHead
                inBrowser
                renderTitle={name => `${name} doesn't work in the browser`}
                renderSubtitle={() => `To activate biometrics, you need to download the Raison app.`}
            />

            <div className='flex flex-col gap-2 p-4'>
                <RsnButton.Primary onClick={getApp}>Get the app</RsnButton.Primary>
                <RsnButton.Secondary onClick={activateLater}>Later</RsnButton.Secondary>
            </div>
        </div>
    );
}
